// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.num[data-v-4e5dbcec] {
  width: 100%;
  border: 1px solid var(--stroke, #e5e0f0);
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  font-size: 13px;
}
.num[data-v-4e5dbcec]:focus {
  outline: none;
  border-color: var(--primary, #6b4eff);
}
.section-header[data-v-4e5dbcec] {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 0.75rem;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.section-header[data-v-4e5dbcec]:hover {
  color: #4b5563;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
